// Single source of truth for the font picker shown in Master Admin → Site
// Styles. Any module-level "font family" control should import this list
// so admins always choose from the same standard set site-wide.
export const GOOGLE_FONTS = [
  { label: "System Default", value: "" },
  { group: "Sans-Serif" },
  { label: "Inter", value: "Inter" },
  { label: "Roboto", value: "Roboto" },
  { label: "Poppins", value: "Poppins" },
  { label: "Raleway", value: "Raleway" },
  { label: "Montserrat", value: "Montserrat" },
  { label: "Nunito", value: "Nunito" },
  { label: "DM Sans", value: "DM Sans" },
  { label: "Plus Jakarta Sans", value: "Plus Jakarta Sans" },
  { label: "Space Grotesk", value: "Space Grotesk" },
  { group: "Serif" },
  { label: "Playfair Display", value: "Playfair Display" },
  { label: "Merriweather", value: "Merriweather" },
  { label: "Lora", value: "Lora" },
  { label: "Cormorant Garamond", value: "Cormorant Garamond" },
  { label: "EB Garamond", value: "EB Garamond" },
  { group: "Modern" },
  { label: "Outfit", value: "Outfit" },
  { label: "Syne", value: "Syne" },
  { label: "Figtree", value: "Figtree" },
];
